import { useApi } from '@backstage/core-plugin-api';
import { useAsync } from 'react-use';
import { dataObservabilityApiRef } from '../../../dataObservabilityApi';

export function useAirflowHosts() {
  const dataObservabilityClient = useApi(dataObservabilityApiRef);
  const { value } = useAsync(() => dataObservabilityClient.getAirflowHostsV2(), [dataObservabilityClient]);
  return value || [];
}
